import {CircuitStatusService, PesAccountService, Rights} from '@pes/ui';
import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';

/**
 * @inheritDoc
 */
@Injectable()
export class LbpaCircuitStatusService extends CircuitStatusService {


    /**
     * The query used to retrieve circuit status for the current entity.
     */
    private readonly _QUERY: any = {
        size: 0,
        aggs: {
            total_per_status: {
                terms: {
                    field: 'meta.status.keyword'
                }
            }
        }
    };

    constructor(protected injector: Injector,
                private readonly _account: PesAccountService) {
        super(injector);
    }

    /**
     * @inheritDoc
     */
    public getCircuitStatus(): Observable<any> {
        if (!this._account.hasRight(Rights.CIRCUIT_LIST_ALL)) {
            this._QUERY.query = {bool: {filter: [{term: {'users.id.keyword': this._account.identity.id}}]}};
        }
        return this.http.post(this.boService.getBaseUrl() + this.path, this._QUERY, this.boService.buildOptions());
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/circuit-status.service.ts